goog.provide("shadow.js.shim.module$$sentry$react");
goog.provide("module$shadow_js_shim_module$$sentry$react");
shadow.js.shim.module$$sentry$react = shadow.js.nativeProvides["@sentry/react"] = shadow$bridge("@sentry/react");
module$shadow_js_shim_module$$sentry$react.default = shadow.js.shim.module$$sentry$react;
